import React from 'react';
import PropTypes from 'prop-types';
import ReactAnimatedNumber from 'react-animated-number';
import { formatNumber } from '@biw/intl';

export default class AnimatedNumber extends React.Component {
    static propTypes = {
        precision: PropTypes.number,
        locale: PropTypes.shape( {} ).isRequired,
        value: PropTypes.number,
        duration: PropTypes.number,
        formatter: PropTypes.func
    };

    formatValue = value => {
        const { precision, locale } = this.props;
        return formatNumber( locale, {
            minimumFractionDigits: precision || 0,
            maximumFractionDigits: precision || 2
        }, value );
    }

    render() {
        const { precision, value, duration, formatter } = this.props;
        return (
            <ReactAnimatedNumber
                value={ value }
                duration={ duration }
                stepPrecision={ precision }
                formatValue={ formatter || this.formatValue }
            />
        );
    }
}
